/**
 * Build a human-readable coupon description from the backend's applied-promotion payload.
 *
 * WHY: the checkout UI used to hard-code "First month FREE" for any 100% off
 * coupon. That wording is wrong for multi-month recurring promos (e.g. the
 * HACK0526 hackathon code, which grants 2 free months). The backend now
 * surfaces Stripe-native `duration` + `durationInMonths` on each applied
 * promotion, and this helper renders them consistently across checkout pages.
 */
export function buildCouponDescription(promotionInfo) {
  if (!promotionInfo) return '';

  const { discountType, discountValue, duration, durationInMonths } = promotionInfo;

  if (discountType === 'percentage' && discountValue === 100) {
    if (duration === 'forever') return 'Free forever';
    if (duration === 'repeating' && durationInMonths > 1) {
      return `First ${durationInMonths} months FREE`;
    }
    return 'First month FREE';
  }

  if (discountType === 'percentage' && discountValue) {
    return `${discountValue}% off`;
  }

  if (discountType === 'fixed_amount' && discountValue) {
    return `$${(discountValue / 100).toFixed(2)} off`;
  }

  return '';
}
